import { render, staticRenderFns } from "./CustomerContactList.vue?vue&type=template&id=50dbb3d5&scoped=true&lang=pug&"
import script from "./CustomerContactList.vue?vue&type=script&lang=js&"
export * from "./CustomerContactList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dbb3d5",
  null
  
)

export default component.exports